/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { UserStatus } from '@gh/builder-shared-data';
import { ROW_DELETED_CLASS } from '@gh/common-internal-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { UserListItem } from '../../resources/office-user-list-item.model';

@Injectable()
export class OfficeUserGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    status: {
      cellClass: ({ data }: { data: UserListItem }) => ({
        [UserStatus.Active]: 'active-status',
        [UserStatus.Inactive]: 'inactive-status',
        [UserStatus.Deleted]: 'deleted-status',
        [UserStatus.Transferred]: 'transfered-status',
      }[data.statusValue || '']),
    },
  };

  options = {
    getRowClass: ({ data }: { data: UserListItem }) => {
      if (data.statusValue === UserStatus.Deleted) {
        return ROW_DELETED_CLASS;
      }
    },
    getRowNodeId: (data: UserListItem) => data.userId,
  };
}
